import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAdminUsers, AdminUser } from "../../services/admin";

interface AdminsState {
  users: AdminUser[];
  loading: boolean;
  hasFetched: boolean;
  error: string | null;
}

const initialState: AdminsState = {
  users: [],
  loading: false,
  hasFetched: false,
  error: null,
};

// ✅ Named export
export const fetchAdminsThunk = createAsyncThunk<AdminUser[], string>(
  "admins/fetchAdmins",
  async (token) => {
    const data = await fetchAdminUsers(token);
    return data;
  }
);

const adminsSlice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    forceRefreshAdmins(state) {
      state.hasFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdminsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.hasFetched = true;
      })
      .addCase(fetchAdminsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch admins";
      });
  },
});

export const { forceRefreshAdmins } = adminsSlice.actions;
export default adminsSlice.reducer;
